export default __webpack_public_path__ + "static/media/speed-idle.a13396f7.jpeg";